import axios from "axios";

const { CancelToken } = axios;
const source = CancelToken.source();
const checkZipCode = async (apiDomain: string, zipCode: string) => {
  try {
    const response = await axios.get(`${apiDomain}/voebiz-utilities/v1/zipcode/check?zipcode=${zipCode}`, {
      cancelToken: source.token,
    });
    return response.data;
  } catch (error: any) {
    return new Error(error);
  }
};

export { checkZipCode, source };
